"use client";

import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { cn } from "@/lib/utils/general-utils";
import { Check, Minus } from "lucide-react";
import * as React from "react";

export interface TableCheckboxProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  indeterminate?: boolean;
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
}

export function TableCheckbox({
  checked = false,
  onChange,
  indeterminate = false,
  disabled = false,
  className,
  ariaLabel,
}: Readonly<TableCheckboxProps>) {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <span onClick={handleClick}>
      <CheckboxPrimitive.Root
        checked={checked}
        indeterminate={indeterminate}
        onCheckedChange={(val) => onChange?.(val === true)}
        disabled={disabled}
        aria-label={ariaLabel}
        className={cn(
          "peer relative flex size-4 shrink-0 items-center justify-center rounded-[4px] border transition-colors outline-none",
          "border-gray-300 hover:border-gray-400",
          "focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring/50",
          "disabled:cursor-not-allowed disabled:opacity-50",
          "cursor-pointer",
          "data-checked:border-primary data-checked:bg-primary data-checked:text-primary-foreground",
          className,
        )}
      >
        <CheckboxPrimitive.Indicator className="grid place-content-center text-current [&>svg]:size-3">
          {indeterminate ? (
            <Minus strokeWidth={3} />
          ) : (
            <Check strokeWidth={3} />
          )}
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    </span>
  );
}
